var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMessageText = function SvgMessageText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6 5.00002C21.6 4.11637 20.8837 3.40002 20 3.40002H4.00001C3.11635 3.40002 2.40001 4.11637 2.40001 5.00002V19.792C2.40001 20.3789 3.07896 20.7052 3.53729 20.3386L6.96047 17.6H20C20.8837 17.6 21.6 16.8837 21.6 16V5.00002ZM20 4.60002C20.2209 4.60002 20.4 4.77911 20.4 5.00002V16C20.4 16.2209 20.2209 16.4 20 16.4H6.53954L3.60001 18.7516V5.00002C3.60001 4.77911 3.77909 4.60002 4.00001 4.60002H20ZM18 7.90002H6.00001V9.10002H18V7.90002ZM6.00001 13.1H16V11.9H6.00001V13.1Z"
  })));
};
export default SvgMessageText;